// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"3a74507d","576":"42d52585","759":"cfd71e62","923":"cfd71e62","2947":"11b01132","4621":"9580e40f","5572":"e7f0c2f3","6454":"bb6547fe","7571":"cfd71e62","8787":"a0b071dc"}[chunkId] + ".chunk.css";
};